import { useContext, useEffect } from "react";
import { useSolicitudesCurso } from "../solicitudes-en-curso/useSolicitudesCurso";
import { modalEjecutar, modalCargando } from "../../components/ui/sweetAlerts";
import { customStyles, paginationComponentOptions, TIPO_DE_SOLICITUD } from "../../utils/Constants";
import { DataContextContractual } from "../../contextData/contextData";
import { InputBusquedaMonitor } from "../../components/InputBusqueda";
import { ModalContractuales } from "../modalForm/modalForm";
import DataTable from "react-data-table-component";
import { useLocation } from "react-router-dom";
import { useEnviarSAP } from "./useEnviarSAP";

export const EnviarSAP = () => {
  const { dataListado } = useContext(DataContextContractual);
  const { traerListado, objModal, visible, hideModal } = useSolicitudesCurso();
  const location = useLocation();
  const {
    seleccionarContrato,
    descargarExcel,
    filtrarSap,
    descargarExcelCambioContrato,
    arrSolicitudes,
    envioMasivoSAP,
    objModalSAP,
    visibleModal,
    hideModalSAP,
    limpioSelected,
  } = useEnviarSAP();

  useEffect(() => {
    modalCargando("Cargando datos...");
    traerListado();
  }, []);

  return (
    <>
      <ModalContractuales
        cerrable={false}
        data={["/envio-a-sap"].includes(location.pathname) ? objModalSAP : objModal}
        show={["/envio-a-sap"].includes(location.pathname) ? visibleModal : visible}
        hideModal={["/envio-a-sap"].includes(location.pathname) ? hideModalSAP : hideModal}
        tamanio={!["/envio-a-sap"].includes(location.pathname) ? "xl" : "lg"}
      />
      <div className="d-flex align-items-center flex-column">
        <div className="col col-12 col-lg-10 px-4">
          <div className="card-header bgArcopime h5 d-flex justify-content-between" style={{ padding: "6px 8px 6px 8px" }}>
            Envío a SAP
            <div className="d-flex gap-2">
              <select
                className="form-control pt-1"
                style={{ height: "30px", fontSize: "14px", width: "240px" }}
                onChange={(e) => {
                  setTimeout(traerListado(e.target.value), 200);
                }}
              >
                <option value=""> -- Seleccione --</option>
                {TIPO_DE_SOLICITUD.map((el) => (
                  <option value={el.value}>{el.label}</option>
                ))}
              </select>
            </div>
          </div>
          <DataTable
            data={dataListado.arrData}
            columns={dataListado.id_columnas}
            customStyles={customStyles}
            dense
            pagination
            selectableRows
            clearSelectedRows={limpioSelected}
            onSelectedRowsChange={seleccionarContrato}
            noDataComponent="No se encontraron registros"
            paginationComponentOptions={paginationComponentOptions}
          />
        </div>
        {dataListado.arrData.length > 0 && (
          <div className="col col-12 col-lg-10 px-4">
            <button
              title="Descargar Excel"
              onClick={() => {
                descargarExcel();
              }}
              className="ms-0 px-4 btnCopec me-2"
            >
              Descargar Excel
            </button>

            <button
              title="Descargar Excel"
              onClick={() => {
                descargarExcelCambioContrato();
              }}
              className="ms-0 px-4 btnCopec me-2"
            >
              Descargar Excel CC
            </button>

            {arrSolicitudes.length > 0 && (
              <>
                <button
                  title="Rechazar"
                  onClick={() => {
                    modalEjecutar(() => {
                      objModalSAP.titulo = "Rechazando Solicitudes";
                      envioMasivoSAP(arrSolicitudes, false);
                    }, "Se procedera a <b>RECHAZAR</b> las solicitudes seleccionadas, ¿Está de acuerdo?");
                  }}
                  className="ms-0 btnAtras me-2"
                >
                  Rechazar
                </button>
                <button
                  title="Enviar a SAP"
                  onClick={() => {
                    modalEjecutar(() => {
                      objModalSAP.titulo = "Enviando a SAP";
                      envioMasivoSAP(arrSolicitudes, true);
                    }, "Se procedera a <b>ENVIAR A SAP</b> las solicitudes seleccionadas, ¿Está de acuerdo?");
                  }}
                  className="ms-0 btnExcel me-2"
                >
                  Enviar a SAP
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};
